import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { Dialog, DialogBody } from '@blueprintjs/core'

import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { APP_CONFIG_MEDIA_MANAGER_PATH } from '@config/app.config'
import { VIEW_TYPES } from '@client/components/constants/index'

import './styles.scss'

// The frontend-v3 media manager, embedded in a dialog. It replaced the legacy
// old.app file manager overlay for every account (FE-1207).

@inject('app')
@observer
class FileManager extends Component {
  static propTypes = {
    app: PropTypes.instanceOf(AppModel),
  }

  static defaultProps = {
    app: AppModelNULL,
  }

  // Only reached via the dialog's own affordances (header close button,
  // backdrop click, Escape on the chrome). Picking a file, and the embedded
  // app's own close button, both come back as postMessages that the settings
  // components turn into their own `setView` calls — see postMessageHandler.
  closeDialog = () => {
    this.props.app.setView(VIEW_TYPES.EDITOR)
  }

  get isOpen() {
    const { view } = this.props.app
    return (
      view === VIEW_TYPES.FILE_MANAGER_FROM_EDITOR ||
      view === VIEW_TYPES.FILE_MANAGER_FROM_SIDEBAR
    )
  }

  getSrc(basePath) {
    const { filemanagerQueryOptions } = this.props.app
    return `${basePath}${
      filemanagerQueryOptions ? `?${filemanagerQueryOptions}` : ''
    }`
  }

  render() {
    const { formatMessage } = this.props.app
    const title = formatMessage('filemanager.dialog.title')

    return (
      <Dialog
        className="filemanager-dialog"
        portalClassName="filemanager-portal"
        icon="media"
        isOpen={this.isOpen}
        onClose={this.closeDialog}
        title={title}
        // Keydowns inside a cross-origin iframe never reach this document, so
        // this only covers the case of focus still being on the dialog chrome.
        // The embedded app handles Escape itself and posts a `close` message.
        canEscapeKeyClose
        // Blueprint's focus trap pulls focus back whenever a document-level
        // focus event fires outside the dialog. Focus entering the iframe
        // leaves `document.activeElement` on the <iframe> element itself,
        // which is inside the dialog, so the trap stays quiet and the embedded
        // app keeps focus.
        enforceFocus
      >
        <DialogBody
          className="filemanager"
          // The iframe fills the body and scrolls its own content; Blueprint's
          // default overflow container would add a second scrollbar.
          useOverflowScrollContainer={false}
        >
          <iframe
            frameBorder="0"
            src={this.getSrc(APP_CONFIG_MEDIA_MANAGER_PATH)}
            title={title}
          />
        </DialogBody>
      </Dialog>
    )
  }
}

export default FileManager
